import React, { useState, useMemo, useEffect } from 'react';
import {
    Button,
    Widget,
    GridView,
    SimpleView,
    Table,
    FormInput,
    ColumnProps,
    MasterDetailForm,
    FormSubmitButton,
    FormatText,
    FormSelect
} from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import { DolarResult, postDolar } from '@app/api/dolar';
import CurrencyInput from '@app/components/CurrencyInput';
import { Form, Input, Button, Radio } from 'antd';


interface DolarPropt {

}

const Dolar = (props: DolarPropt) => {

    const { } = [props];

    const [valorInicial, setValorInicial] = useState<DolarResult>();

    const harPostDolar = (values: any) => {
        const form = values as DolarResult;        
        postDolar(form);
    }

    useEffect(() => {
    }, [])

    return (
        <SimpleView >
            <GridView
                noform>
                <MasterDetailForm
                    initialValues={valorInicial}
                    onSubmit={values => {                       
                        harPostDolar(values);
                    }}>
                    <Widget
                        actions={[
                            hasPermission([
                                'DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR',
                                'DIRETORIA_AREA_DEPARTAMENTO_EDITAR',
                            ]) && (
                                <FormSubmitButton type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>

                            ),
                        ]}>

                        <div className="ant-col ant-form-item-label">
                            <label className="ant-form-item-no-colon" title="">
                                <span className="ant-app-text">Valor</span>
                            </label>
                            <CurrencyInput
                                id={`valorDolarForm`}
                                name={`valorDolarForm`}
                                value={valorInicial ? valorInicial.valor : 0}
                                defaultValue={valorInicial ? valorInicial.valor : 0}
                                onChange={e => {                                    
                                    const novaValor = { ...valorInicial, valor: e } as DolarResult;
                                    setValorInicial(novaValor);

                                }}
                            />
                        </div>

                    </Widget>
                </MasterDetailForm>

            </GridView>
        </SimpleView>

    );
}

export default Dolar;